<template>
  <div class="nuttrema-table-column"
    :class="[`theme-${theme}`]"
    :style="styleProps">
    <slot>
      <div if="label" class="label">{{ $t(label) }}</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-table-column',
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: 'regular',
    },
    styleProps: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~assets/styles/theme/colors';

  .nuttrema-table-column {
    display: flex;
    align-self: stretch;
    align-items: center;
    justify-content: left;
    flex-shrink: 0;

    flex-basis: auto;

    overflow: hidden;
    position: relative;
    margin-left: 0.75em;

    &:last-child {
      margin-right: 0.75em;
    }

    .two-line-text {
      display: flex;
      position: absolute;
      flex-direction: column;
      justify-content: center;
      top: 0; left: 0; right: 0; bottom: 0;

      &.is-link {
        &:hover, &:focus, &:active {
          cursor: pointer;
        }
      }

      .two-line-text__title, .two-line-text__description, .two-line-text__origin {
        > span {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          display: inline-block;
          text-overflow: ellipsis;
        }
      }

      .two-line-text__title {
        line-height: 1.25;
        > span {
          font-weight: 500;
        }
      }

      .two-line-text__description {
        line-height: 1.15;
        margin-top: -0.15em;
        > span {
          font-size: 0.9em;
        }
      }

      .two-line-text__origin {
        line-height: 1.15;
        margin-top: -0.15em;
        > span {
          font-size: 0.8em;
          font-weight: 500;
          color: $gray-light;
        }
        &.is-upper {
          > span {
            text-transform: uppercase;
            font-size: 0.7rem;
          }
        }
      }
    }

    &.theme-header {
      > .label {
        display: flex;
        font-weight: 500;
        font-size: 0.8rem;
        padding: 0.25em 0;
        color: $gray-light;
        text-transform: uppercase;
        i {
          margin-left: 1em;
          line-height: 1.25;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/table/nuttrema-table-column.vue